import URL from '@/api/URL';
import fetch from '@/api/fetch';

export function login (params) {
  return fetch.post(URL.login, params);
}

export function logout (params) {
  return fetch.post(URL.logout, params);
}

export function loginIndex (params) {
  return fetch.post(URL.loginIndex, params);
}



// WEBPACK FOOTER //
// ./src/api/modules/login.js